module.exports = __webpack_public_path__ + "img/gb9113_12_a.prt.3d5ffa3a.jpg";